module.exports = __webpack_public_path__ + "static/media/navbar-top-menu.31367464.svg";